import React, { useState } from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import {
  getHorizontalOptions,
  getVerticalOptions,
} from "../utilities/optionGeneration";

import ImageComponent from "../CustomComponent/ImageComponent";
export default function AdvertisementForm({
  verticalValue,
  horizontalValue,
  handleChangeHorizontal,
  handleChangeVertical,
  handleChangeImg,
  image,
  handleFormToFile,
  setOriginalFile,
  date,
  setDate,
  number,
  setNumber,
  sector,
  paper,
  paperType,
  sectorType,
  setSectorType,
  setPaperType,
}) {
  const horz = getHorizontalOptions(8);
  const vert = getVerticalOptions(42);

  return (
    <div className="all">
      <h2 className="title">Publish your ad</h2>
      <div className="row">
        <div className="col-md-6">
          <div className="input-content-block ">
            <p className="content">
              Horizontal <i className="bx bx-move-horizontal"></i>{" "}
              <span style={{ color: "#8c8b8b" }}>[ Note: 1 col = 4 cm ]</span>
            </p>
            <select
              value={horizontalValue}
              onChange={handleChangeHorizontal}
              className="input-field role_category_select"
            >
              {horz.map((opt, index) => (
                <option key={index} value={opt}>
                  {opt} col
                </option>
              ))}
            </select>
          </div>
          <div className="input-content-block ">
            <p className="content">
              Vertical<i className="bx bx-move-vertical"></i>{" "}
            </p>
            <select
              value={verticalValue}
              onChange={handleChangeVertical}
              className="input-field role_category_select"
            >
              {vert.map((opt, index) => (
                <option key={index} value={opt}>
                  {opt} cm
                </option>
              ))}
            </select>
          </div>
          <div className="row ">
            <div className="col-md-6">
              <div className="input-content-block ">
                <p className="content">Sector Type</p>
                <select
                  value={sectorType}
                  onChange={(e) => setSectorType(e.target.value)}
                  className="input-field role_category_select"
                >
                  <option value="">Select</option>
                  {sector.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.sector_type}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-content-block ">
                <p className="content">Page</p>
                <select
                  value={paperType}
                  onChange={(e) => setPaperType(e.target.value)}
                  className="input-field role_category_select"
                >
                  <option value="">Select</option>
                  {paper.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.paper_type}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="row ">
            <div className="col-md-6">
              <div className="input-content-block">
                <p className="content">Publish Date</p>
                <DatePicker
                  className="input-field full-width"
                  selected={date}
                  value={date}
                  minDate={new Date()}
                  dateFormat={"yyyy-MM-dd"}
                  onChange={(date) => {
                    setDate(date);
                  }}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-content-block">
                <p className="content">Phone No.</p>
                <input
                  type="number"
                  className="input-field"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="file-btn-visible">
            <label>
              Upload Image
              <input
                type="file"
                name="image-upload"
                accept="image/*,.doc, .docx,.txt,.pdf"
                onChange={(e) => {
                  if (e.target.files[0]) {
                    handleChangeImg(URL.createObjectURL(e.target.files[0]));
                    setOriginalFile(e.target.files[0]);
                  }
                }}
              />
            </label>
          </div>
        </div>
        <div className="col-md-6">
          <div
            className="ad-form-image block-card"
            style={{ marginTop: "20px" }}
          >
            <ImageComponent image={image} />
          </div>
        </div>
        <div className="col-md-12">
          <div className="btn-block-center">
            <button
              className="main-btn "
              onClick={() => {
                handleFormToFile();
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
